import { FileBase } from "../../../modules/files";
export class PeerFile extends FileBase {
    constructor(fileId) {
        super(fileId);
    }
}
